export class Game {

  name;
  id;
  logo;

  constructor({ _id, uuid, name,logo }) {
    this.name = name;
    this.id = uuid || _id;
    this.logo = logo || '';
  }
}